<template>
  <div>
    <v-row v-if="files.length > 0" >
      <v-col cols="12" sm="12" md="3" lg="3" v-for="(item, index) in files" :key="index" align="center">
        <a v-if="item.type.indexOf('image') !== -1" :href="item.url" target="_blank">
          <v-hover v-slot:default="{ hover }">
            <v-card
              flat
              tile
              class="d-flex"                              
              :elevation="hover ? 16 : 2"
            >
              <v-img                                  
                :src="item.url"
                :lazy-src="item.url"                                  
                class="grey lighten-2"
                aspect-ratio="1"
              ></v-img>
            </v-card>
          </v-hover>
        </a>                   
        <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
          <v-img
              width="67" height="85"
              src="/static/img/pdf.png"
              aspect-ratio="1"
            ></v-img>
        </a>                                                                                                               
        <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
          <v-img
              width="67" height="85"
              src="/static/img/ppt.png"
            ></v-img>
        </a>
        <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
          <v-img
              width="67" height="85"
              src="/static/img/doc.png"
            ></v-img>
        </a>
        <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
          <v-img
              width="67" height="85"
              src="/static/img/text.png"
            ></v-img>
        </a>      
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'FilePreview',
  props: ['files']
}
</script>



// WEBPACK FOOTER //
// FilePreview.vue?83de6380